import { css } from "@emotion/react";
import { FC } from "react";

import { DesignToken } from "@livechat/design-system-react-components";

import { withVar } from "themes/helpers";

const containerStyles = css`
  padding: 90px 20px;
  text-align: center;
`;

const imageStyles = css`
  margin-bottom: 48px;
`;

const titleStyles = css`
  font-size: 24px;
  line-height: 32px;
  font-weight: 600;
  max-width: 440px;
  margin: 0 auto 12px auto;
  color: ${withVar(DesignToken.ContentBasicPrimary)};
`;

const descriptionStyles = css`
  margin-bottom: 20px;
  font-size: 18px;
  font-weight: 400;
  line-height: 24px;
  color: ${withVar(DesignToken.ContentBasicSecondary)};
`;

const buttonStyles = css``;

interface IProps {
  icon?: string;
  title?: string;
  description?: React.ReactNode;
  button?: React.ReactElement;
}

export const NoMobileScreen: FC<IProps> = ({ icon, title, description, button }) => (
  <div css={containerStyles}>
    {icon && (
      <div css={imageStyles}>
        <img src={icon} alt="" />
      </div>
    )}
    {title && <div css={titleStyles}>{title}</div>}
    {description && <div css={descriptionStyles}>{description}</div>}
    {button && <div css={buttonStyles}>{button}</div>}
  </div>
);
